__turbopack_context__.v({
  "className": "rubik_571ea313-module__5GvwkG__className",
});
